import { createQueryKeys } from '@lukemorales/query-key-factory'

export const enterpriseMembership = createQueryKeys('enterprise-membership', {
  info: null,
  invitationById: (invitationId: number | string) => [{ invitationId }],
  receivedInvitations: null,
})
